
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands, getDateRange } from "@common/src/utils/common";
import dayjs from "dayjs";
import { Table, TableRowsSelect, InjectFunction } from "@common/src/utils/decorator";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { formDownload } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";
import appCode from "@common/src/utils/app-code";
import { OpDefalutQueryStore } from "@common/src/utils/constant";

const statement = namespace("statement");
const base = namespace("base");
const management = namespace("management");
const serviceItem = namespace("service-item");
const parts = namespace("parts");
const common_statement = namespace("common_statement");

@InjectFunction("permitApp")
@Component({})
@Table("loadListData")
export default class TurnoverList extends Vue {
  @statement.Action getTurnOverPageModelPage;
  @base.Action getDictionaryList;
  @management.Action getStoreList;
  @serviceItem.Action getServiceItemList;
  @parts.Action getPartsList;
  @common_statement.Mutation setSearchForm;
  @common_statement.Mutation setSearchList;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm: any = {
    storeCode: "", // 门店名称
    area: "", // 所在地区
    stateName: "", // 省级名称
    cityName: "", // 市级名称
    districtName: "", // 县级名称
    timeFrameType: "date", // 时间范围类型, date-按日,month-按月
    startTime: "", // 开始时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    endTime: "", // 结束时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    businessType: "services", // 服务类型，services-服务项目,parts-零配件
    businessCodeList: [] // 服务编码列表
  };
  contentList: any = [];
  dataLastUpdateTime: any = "";

  created() {
    if (this.permitApp("speedbiz-operation")) {
      this.searchForm.storeCode = OpDefalutQueryStore.value;
    }
    this.init();
  }
  toStatementView(row) {
    if (row) {
      const dateFormat = row.dateTip.replace(/-/g, "");
      this.$router.push({
        name: "statementTurnoverView",
        params: {
          fromList: "1",
          ...this.searchForm,
          startTime: dateFormat,
          endTime: dateFormat
        }
      });
    } else {
      this.$router.push({
        name: "statementTurnoverView",
        params: {
          fromList: "1",
          ...this.searchForm
        }
      });
    }
  }

  storeList: any = [OpDefalutQueryStore];
  serviceList: any = [];
  partsList: any = [];
  serviceListCopy: any = [];
  partsListCopy: any = [];
  get searchList() {
    return [
      {
        label: t("v216_6.statistical-dimension"),
        type: "btn-radio",
        prop: "timeFrameType",
        options: this.dateTypeOptions,
        value: this.searchForm.timeFrameType,
        typeChangeMethod: this.handleDateTypeChange,
        required: true
      },
      {
        if: this.searchForm.timeFrameType === "date",
        label: t("v210831.time-frame"),
        value: [this.searchForm.startTime, this.searchForm.endTime],
        resetValue: this.getDefaultDate("date"),
        type: "daterange",
        prop: "date",
        required: true,
        disabledFuture: true,
        maxDay: 90,
        valueDistribute: ["startTime", "endTime"]
      },
      {
        if: this.searchForm.timeFrameType === "month",
        label: t("v210831.time-frame"),
        value: [this.searchForm.startTime, this.searchForm.endTime],
        resetValue: this.getDefaultDate("month"),
        type: "monthrange",
        prop: "month",
        required: true,
        disabledFuture: true,
        maxMonth: 12,
        valueDistribute: ["startTime", "endTime"]
      },
      {
        if: appCode === "speedbiz",
        label: t("service.project-spare-parts"),
        type: "btn-radio",
        prop: "businessType",
        options: this.itemTypeOptions,
        value: this.searchForm.businessType,
        typeChangeMethod: this.handleItemTypeChange,
        required: true
      },
      {
        if: appCode === "speedbiz" && this.searchForm.businessType === "services",
        label: t("v213.Service"),
        type: "select-search",
        prop: "businessCodeList1",
        valueAlias: "businessCodeList",
        value: this.searchForm.businessCodeList,
        selectList: this.serviceList,
        searchFun: this.searchService,
        multiple: true
      },
      {
        if: appCode === "speedbiz" && this.searchForm.businessType === "parts",
        label: t("parts.text"),
        type: "select-search",
        prop: "businessCodeList2",
        valueAlias: "businessCodeList",
        value: this.searchForm.businessCodeList,
        selectList: this.partsList,
        searchFun: this.searchParts,
        multiple: true
      },
      {
        if: appCode === "speedbiz-operation",
        label: t("staff.store"),
        type: "select-search",
        value: OpDefalutQueryStore.value,
        prop: "storeCode",
        selectList: this.storeList,
        searchFun: this.searchStore,
        clearable: false
      },
      {
        if: appCode === "speedbiz-operation",
        label: t("setting.region"),
        type: "area",
        value: "",
        labels: [],
        prop: "area",
        anyLevel: true,
        valueDistribute: ["stateName", "cityName", "districtName"]
      }
    ].filter(item => item.if !== false);
  }
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = (data.data?.list || []).map(item => {
        item.label = item.storeName;
        item.value = item.storeCode;
        return item;
      });
    });
  }
  searchService(val = "") {
    this.getServiceItemList({
      status: "1",
      pageNum: 1,
      pageSize: 10,
      searchKey: val
    }).then(data => {
      let list = data.data.list
        ? data.data.list.filter(item => {
            item.label = item.serviceName;
            item.value = item.serviceCode;
            return !this.serviceListCopy.find(v => v.value === item.value);
          })
        : [];
      this.serviceList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.serviceName;
            item.value = item.serviceCode;
            return item;
          })
        : [];
      this.serviceListCopy = [...list, ...this.serviceListCopy];
    });
  }
  searchParts(val = "") {
    this.getPartsList({
      status: "1",
      pageNum: 1,
      pageSize: 10,
      partsName: val
    }).then(data => {
      let list = data.data.list
        ? data.data.list.filter(item => {
            item.label = item.partsName;
            item.value = item.partsCode;
            return !this.partsListCopy.find(v => v.value === item.value);
          })
        : [];
      this.partsList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.partsName;
        item.value = item.partsCode;
        return item;
      });

      this.partsListCopy = [...list, ...this.partsListCopy];
    });
  }
  init() {
    if (appCode === "speedbiz-operation") {
      this.searchStore("");
    } else if (appCode === "speedbiz") {
      this.searchService("");
      this.searchParts("");
    }
    this.handleDateTypeChange(this.searchForm.timeFrameType);
    this.handleSearch(this.searchList);
  }
  handleExportData() {
    formDownload(`${window.API_URL}/report/turnOver/exportTurnOverPage`, this.searchForm);
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getTurnOverPageModelPage({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      if (data.data.dataLastUpdateTime) {
        this.dataLastUpdateTime = data.data.dataLastUpdateTime;
      }
      this.contentList = data.data.list;
      return data;
    });
  }
  @TableRowsSelect.updateMethod
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.valueAlias || item.prop] = item.value;
      }
    });
    if (this.permitApp("speedbiz-operation") && !this.searchForm.storeCode) {
      return this.$message.error(t("v210831.please-select-a-store"));
    }
    this.loadListData();
  }
  dateTypeOptions = [
    { label: t("sb_copy.query-by-day"), value: "date" },
    { label: t("sb_copy.query-by-month"), value: "month" }
  ];
  itemTypeOptions = [
    { label: t("v213.Service"), value: "services" },
    { label: t("parts.text"), value: "parts" }
  ];
  handleDateTypeChange(val) {
    [this.searchForm.startTime, this.searchForm.endTime] = this.getDefaultDate(val);
    this.searchForm.timeFrameType = val;
  }
  handleItemTypeChange(val) {
    this.searchForm.businessCodeList = [];
    this.searchForm.businessType = val;
  }

  getDefaultDate(type: "date" | "month"): Array<string> {
    if (type === "date") {
      return getDateRange("first_day_to_today_of_current_month", "YYYYMMDD");
    } else if (type === "month") {
      return getDateRange("first_month_to_current_month_of_current_year", "YYYYMM");
    } else {
      return [];
    }
  }
}
